import { EnumStatusSafra, StatusSafra } from './../../../../classes/Safra';
import { EtapaService } from './../../../../services/etapa.service';
import { Etapa } from 'src/app/classes/Etapa';
import { AtividadePlanejamento } from 'src/app/classes/AtividadePlanejamento';
import { StorageService } from 'src/app/services/storage.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AnoSafra, EnumStatusAnoSafra } from 'src/app/classes/AnoSafra';
import { Safra } from 'src/app/classes/Safra';
import { SafraService } from 'src/app/services/safra.service';
import Swal from 'sweetalert2';
import { Fazenda } from 'src/app/classes/Fazenda';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';
import { Cultura } from 'src/app/classes/Cultura';
import { Area } from 'src/app/classes/Area';
import { AreaService } from 'src/app/services/area.service';
import { Planejamento } from 'src/app/classes/Planejamento';
import { Cultivar } from 'src/app/classes/Cultivar';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { FazendaService } from 'src/app/services/fazenda.service';
import { AnoSafraService } from 'src/app/services/ano-safra.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/classes/Usuario';
import { enumErpIntegrado } from 'src/app/classes/Empresa';
import { UtilsService } from 'src/app/utils/utils.service';
import { ItensAtividade } from 'src/app/classes/ItensAtividade';
import { AtividadePlanejamentoService } from 'src/app/services/atividade-planejamento.service';
import { AtividadeSafra } from 'src/app/classes/AtividadeSafra';
import { AnoAgricolaService } from 'src/app/services/ano-agricola.service';
import { AnoAgricola } from 'src/app/classes/AnoAgricola';
import { ProcessoPlanejamento } from 'src/app/classes/ProcessoPlanejamento';
import { Setor } from 'src/app/classes/Setor';
import { SetorService } from 'src/app/services/setor.service';
import { TranslateService } from '@ngx-translate/core';
import { AreaConfigModalComponent } from './area-config-modal/area-config-modal.component';
import { ProcessoPlanejamentoService } from 'src/app/services/processo-planejamento.service';
import { AuxPlanejamentoSafraAreas } from 'src/app/classes/auxiliar/AuxPlanejamentoSafraAreas';
import { isNull } from 'lodash';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';
import { FormsAnoSafraComponent } from '../forms-ano-safra/forms-ano-safra.component';
import { CulturaService } from 'src/app/services/cultura.service';
import { FormsCulturaSafraComponent } from '../forms-cultura-safra/forms-cultura-safra.component';
import { Observable } from 'rxjs';
import { ConfigProjetoCulturaComponent } from '../projeto/config-projeto-cultura/config-projeto-cultura.component';

interface resumo{
  culturaId: number;
  culturaDescricao: string;
  grupoProdutoId: number;
  grupoProdutoDescricao: string;
  area: number;
}

@Component({
  selector: 'app-safra-tab-lateral',
  templateUrl: './safra-tab-lateral.component.html',
  styleUrls: ['./safra-tab-lateral.component.scss']
})
export class SafraTabLateralComponent implements OnInit {
  @ViewChild('ModalExcluirSafra', { static: false })
  ModalExcluirSafra: UiModalComponent;
  @ViewChild('FormsAnoSafra', { static: false })
  formsAnoSafra: FormsAnoSafraComponent;
  @ViewChild('FormsCultura', { static: false })
  formsCultura: FormsCulturaSafraComponent;
  @ViewChild('FormsConfigProjeto', { static: false })
  FormsConfigProjeto: ConfigProjetoCulturaComponent;
  modalOpened = new EventEmitter<void>();
  @Input() carregando: boolean = false;
  @Input() anosSafras: AnoSafra[];
  @Input() fazendas: Fazenda[];
  @Input() culturas: Cultura[] = [];
  @Input() cultivares: Cultivar[];
  @Input() planejamentoExcluido: Planejamento;
  @Input() anoSafraId: number;

  @Output() attListaAnosSafras: EventEmitter<AnoSafra[]> = new EventEmitter();
  @Output() changeSafra: EventEmitter<Safra> = new EventEmitter();
  @Output() changeCultura: EventEmitter<Cultura> = new EventEmitter();
  @Output() changeAnoSafra: EventEmitter<AnoSafra> = new EventEmitter();
  @Output() changeFazenda: EventEmitter<Fazenda> = new EventEmitter();
  @Output() edicaoSafra: EventEmitter<boolean> = new EventEmitter();
  @Output() iniciarSafra = new EventEmitter();
  @Output() gerenciarTalhoes = new EventEmitter();
  @Output() onExcluirAnoSafra: EventEmitter<boolean> = new EventEmitter()
  @Output() onOperacaoAnoSafraEvent: EventEmitter<boolean> = new EventEmitter()


  culturasSafra: Cultura[] = [];
  fazendaSelecionada : Fazenda;
  anoSafraSelecionado : AnoSafra;
  safraSelecionada: Safra;
  culturaSelecionado: Cultura;
  anoSafraEdit: AnoSafra;
  safras: Safra[];
  areas: Area[];
  setores: Setor[];
  auxAreas: Area[];
  textoBuscaArea: string;
  safraModal: Safra = new Safra();
  areasSafra: Area[];
  planosMestre: Planejamento[];
  areaTotalSafra: number = 0;
  public isSubmit: boolean;
  public isSubmitEdit: boolean;
  mostraEdicaoSafra: boolean;
  resumos: resumo[];
  atividadesSafra: AtividadeSafra[];
  itensAtividades: ItensAtividade[];
  areaIrrigada:Area[] = [];
  areaSequeiro:Area[] = [];
  informarPlantio: boolean = false;
  usuario: Usuario = new Usuario();
  areasPlanejamento:AuxPlanejamentoSafraAreas[] = [];
  controleIdPlanejamentoSafra: number = 1;
  integraTotvs: boolean = false;
  integraSankhya: boolean = false;

  etapas: Etapa[] = [];

  statusSafraAtivo: string = "Status";
  listaStatusSafra = StatusSafra;
  anosAgricolas: AnoAgricola[];
  processosPlanejamento: ProcessoPlanejamento[];
  usaSetor: boolean = false;

  areaConfig: Area = new Area();
  areasConfig: Area[] = [];
  isEditArea: boolean = false;
  fazendaId: number;
  @ViewChild('AreaConfigModal', { static: false }) AreaConfigModal: AreaConfigModalComponent;

  statusFiltroSafra: number = 0;
  // tradução
ERRO: string = 'Erro!';
FEITO: string = 'Feito!';
ANO_SAFRA_DELETADO: string = 'Ano Safra deletado!';
NAO_E_POSSIVEL_EXCLUIR_UM_ANO_SAFRA_QUE_POSSUI_SAFRAS: string = 'Não é possível excluir um ano safra que possui safras!';
SIM: string = 'Sim';
CANCELAR: string = 'Cancelar';
SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
ANO_SAFRA_ALTERADO: string = 'Ano Safra alterado!';
ANO_SAFRA_CADASTRADO: string = 'Ano Safra cadastrado!';
SAFRA_REABERTA: string = 'Safra Reaberta!';
SAFRA_FINALIZADA: string = 'Safra finalizada!';
FINALIZAR_ESTA_SAFRA: string = 'Finalizar esta Safra?';
SAFRA_DELETADA: string = 'Safra deletada!';
SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA_CASO_JA_TENHAM_ORDENS_DE_SERVICOS_GERADAS_TAMBEM_SERAO_EXCLUIDAS: string = 'Se deletar, esta ação não poderá ser desfeita! Caso já tenham Ordens de Serviços geradas, também serão excluídas.';
SAFRA_CADASTRADA: string = 'Safra cadastrada!';
REABRIR_ESTA_SAFRA: string = 'Reabrir esta Safra?';

  constructor(private safraService: SafraService,
    private anoAgricolaService: AnoAgricolaService,
    private areaService: AreaService,
    private fazendaService: FazendaService,
    private anoSafraService: AnoSafraService,
    private planejamentoService: PlanejamentoService,
    private toasty: CustomToastyService,
    private router: Router,
    private storageService: StorageService,
    private utils: UtilsService,
    private atividadePlanejamentoService: AtividadePlanejamentoService,
    private etapaService: EtapaService,
    private setorService: SetorService,
    private translate: TranslateService,
    private culturaService: CulturaService,
    private processoPlanejamentoService: ProcessoPlanejamentoService) { }

  ngOnInit() {
    this.anoSafraEdit = new AnoSafra();
    this.informarPlantio = this.router.url.includes('informar-plantio');
    this.integraTotvs = this.storageService.getEmpresa().ErpIntegrado == enumErpIntegrado.Totvs_RM;
    this.integraSankhya = this.storageService.getEmpresa().ErpIntegrado == enumErpIntegrado.Sankhya;
    this.usaSetor = this.storageService.getEmpresa().UsaSetores;
    this.fazendaId = this.storageService.getFazenda().Id;
    this.planosMestre =[];
    this.planejamentoService.getPlanosMestrePorCultura(0).subscribe(ret =>{
      this.planosMestre = ret;
    },
    err => {
      this.utils.getErro(err);
      this.carregando = false;
    });

    this.etapaService.getEtapas().subscribe(ret =>{
      this.etapas = ret;
    });

    this.usuario = this.storageService.getUsuario();

    this.anoAgricolaService.getAnosAgricolas().subscribe(res => {
      this.anosAgricolas = res;
    });

    this.processoPlanejamentoService.getProcessosPlanejamento().subscribe(res => {
      this.processosPlanejamento = res;
    });
    this.onLoad();

  }

  ngOnChanges() {
    this.onLoad();
  }

  onLoad() {

    if (this.anoSafraId && this.anosSafras != null && this.anosSafras.length > 0) {
      const anoSafraEncontrado = this.anosSafras.find(a => a.Id === this.anoSafraId);
      if (anoSafraEncontrado) {
        this.selecionarAnoSafra(anoSafraEncontrado, true);
        return;
      }
    }

    if (this.anoSafraService.anoSafraSelecionado == null) {
      if (this.anoSafraSelecionado == null && this.anosSafras != null && this.anosSafras.length > 0)
        this.selecionarAnoSafra(this.anosSafras[this.anosSafras.length-1], true);
    } else
      this.selecionarAnoSafra(this.anoSafraService.anoSafraSelecionado, true);

    if (this.fazendaService.fazendaSelecionada == null) {
      if (this.fazendaSelecionada == null && this.fazendas != null && this.fazendas.length > 0){
        if(this.storageService.getFazenda())
          this.selecionarFazenda(this.storageService.getFazenda(), true);
        else
          this.selecionarFazenda(this.fazendas[this.fazendas.length-1], true);
      }
    } else
      this.selecionarFazenda(this.fazendaService.fazendaSelecionada, true);

  }

  listarPlanejamentos(culturaId:number): Planejamento[]{
    if (!culturaId  || culturaId <= 0){
      return [];
    }
    let auxCultivares: number[] = [];
    this.cultivares.filter(x => x.CulturaId == culturaId).forEach(x=>{
      auxCultivares.push(x.Id);
    });
    let auxPlanosMestre: Planejamento[] = [];
    auxPlanosMestre = this.planosMestre.filter(x => x.CulturaId == culturaId);
    return auxPlanosMestre;
  }

  configurarProjeto(cultura: Cultura): void{
    this.FormsConfigProjeto.abrirModal(this.anoSafraSelecionado.Id, cultura.Id, this.fazendaId)
  }

  removerAreaConfigurada(index: number, area: Area){
    let areasConfig = this.areasPlanejamento.filter(x => x.AreaId == area.Id);
    areasConfig[0].Areas.splice(index, 1);
    if(area.Irrigado)
      this.areaIrrigada = this.calculaAreaRestante(this.areaIrrigada, area, areasConfig[0].Areas);
    else
      this.areaSequeiro = this.calculaAreaRestante(this.areaSequeiro, area, areasConfig[0].Areas);
  }

    configurarArea(item: Area, isEdit: boolean, openModal: boolean = true) {
    if(item.CulturaId == null || item.CulturaId == undefined || item.CulturaId == 0){
      item.CulturaId = this.safraModal.CulturaId;
    }
    if(item.AreaUtilizada == 0)
       item.AreaUtilizada = item.AreaDisponivel;

    //calcula área disponível para o modal
    let areasConfiguradas = this.calculaAreaRestante(this.areas, item, this.getAreasConfiguradas(item.Id));
    this.areasConfig = areasConfiguradas.filter(x => x.Id == item.Id);
    item.AreaDisponivel = areasConfiguradas.filter(x => x.Id == item.Id)[0].AreaDisponivel;
    this.areaConfig = item;
    this.isEditArea = isEdit;

    if(openModal)
      this.abrirAreaConfigModal();
  }

  abrirAreaConfigModal(){
    this.AreaConfigModal.Modal.show();
    this.modalOpened.emit();
  }

  selecionarCultura(cultura: Cultura){
    this.culturaSelecionado = cultura;
    this.changeCultura.emit(this.culturaSelecionado);
  }

  selecionarFazenda(fazenda: Fazenda, onload?: boolean) {
    if (this.fazendaSelecionada == null || this.fazendaSelecionada.Id != fazenda.Id) {
      if (!onload){
        this.safraService.safraSelecionada = null;
        // this.selecionarSafra(null);
      }
      this.fazendaSelecionada = fazenda;
      this.changeFazenda.emit(this.fazendaSelecionada);
      this.fazendaService.fazendaSelecionada = fazenda;

      //this.listarSafras();
    }
  }

  selecionarAnoSafra(anoSafra: AnoSafra, onload?: boolean) {
    this.anoSafraSelecionado = anoSafra;
    this.changeAnoSafra.emit(anoSafra);
      //this.anoSafraService.anoSafraSelecionado = anoSafra;
  }

  // listarCulturas(ultimaCultura: boolean = false): void{
  //   console.trace('listarCulturas')
  //   if (this.anoSafraSelecionado == null)
  //     return;

  //   this.carregando = true;
  //   this.safraService.getCulturaPorAnoSafra(this.anoSafraSelecionado.Id, this.fazendaId).subscribe(
  //     res => {
  //       console.debug('Culturas', res)
  //       this.culturasSafra = res.filter(p => p != null);
  //       this.carregando = false;

  //       if(this.culturasSafra.length > 0){
  //         if(ultimaCultura){
  //           const ultimoCriado = this.culturasSafra.reduce((maisRecente, atual) => {
  //             return new Date(atual.DataCadastro) > new Date(maisRecente.DataCadastro)
  //               ? atual
  //               : maisRecente;
  //           })
  //           this.selecionarCultura(ultimoCriado)
  //         }
  //         else
  //           this.selecionarCultura(this.culturasSafra[0]);
  //       }
  //     },
  //     err => {
  //       this.utils.getErro(err);
  //       this.carregando = false;
  //     }
  //   )
  // }

inserirCultura(): void{
  this.formsCultura.abrirModal();
}


  preencheAreaPorFazenda(){
    this.areaIrrigada = this.getAreaPorFazenda(true);
    this.areaSequeiro = this.getAreaPorFazenda(false);
    this.areaIrrigada = this.areaIrrigada.map(x => {x.AreaDisponivel = x.AreaTotal; x.AreaUtilizada = 0; return x;});
    this.areaSequeiro = this.areaSequeiro.map(x => {x.AreaDisponivel = x.AreaTotal; x.AreaUtilizada = 0; return x;});
  }

  getAreasConfig(irrigado:boolean) : Area[]{
    let retorno:Area[] = [];
    this.areasPlanejamento.forEach(x => {
    let area = this.areas.filter(a => a.Id == x.AreaId && a.Irrigado == irrigado);
    if(!isNull(area) && area.length > 0)
     x.Areas.forEach(c => {c.Selecionada = true;
       retorno.push(c);
      });
    });
    return retorno;
  }

  getAreaPorFazenda(irrigado: boolean) : Area[] {
    if (!this.areas || !this.fazendaSelecionada)
      return [];

    let area = this.areas.filter(x =>
      x.FazendaId==this.fazendaSelecionada.Id && x.Irrigado == irrigado && x.Ativo
    );

    //area.sort((a, b) => a.Descricao.localeCompare(b.Descricao));

    return area;
  }
  calculaAreaRestante(areas:Area[], area:Area, areasConfiguradas:Area[]) : Area[]{
    areas.forEach(a => {
      if(a.Id == area.Id)
      {
        a.AreaUtilizada = 0;
        let areaConfig = areasConfiguradas.filter(x=>x.Id == area.Id);
        areaConfig.forEach(x => {
          a.AreaUtilizada += x.AreaUtilizada;
        });
        a.AreaDisponivel = Number((area.AreaTotal - a.AreaUtilizada).toFixed(2));
      }
    });
    return areas;
  }

  changeArea(areaRef: Area, validar: boolean = true){
    //cria uma copia da área para não alterar a original
    let area:Area = JSON.parse(JSON.stringify(areaRef));
    //verifica se a área já foi configurada antes
    const areaExistente = this.areasPlanejamento.find(a => a.AreaId === area.Id);

    //caso não exista, adicionar a área selecionada ao objeto de controle
    if((areaExistente == null || isNull(areaExistente)) && area.Selecionada){
        let areaConfig:Area[] = [];
        area.IdPlanejamentoSafra = this.controleIdPlanejamentoSafra;
        this.controleIdPlanejamentoSafra++;
        areaConfig.push(area);
        this.areasPlanejamento.push({AreaId: area.Id, Areas: areaConfig});
    }
    else
    {
      //caso a área tenha sido marcada, adicionar a área ao objeto de controle
      let areaConfig:Area[] = this.areasPlanejamento.find(a => a.AreaId === area.Id).Areas;
      let areaAtual = areaConfig.find(a => a.IdPlanejamentoSafra === area.IdPlanejamentoSafra);
      if(areaAtual == null || isNull(areaAtual)){
        areaAtual = area;
        areaAtual.IdPlanejamentoSafra = this.controleIdPlanejamentoSafra;
        this.controleIdPlanejamentoSafra++;
        areaConfig.push(areaAtual);
      }
      else{
        areaAtual = area;
        areaConfig = areaConfig.map(obj => obj.IdPlanejamentoSafra === area.IdPlanejamentoSafra ? areaAtual : obj);
      }
      areaExistente.Areas = areaConfig;
      this.areasPlanejamento.map(obj => obj.AreaId === area.Id ? areaExistente : obj);
    }
    let areaConfig:Area[] = this.areasPlanejamento.find(a => a.AreaId === area.Id).Areas;
    let areaAtual = areaConfig.find(a => a.IdPlanejamentoSafra === area.IdPlanejamentoSafra);

    if(areaAtual.Irrigado)
      this.areaIrrigada = this.calculaAreaRestante(this.areaIrrigada, areaAtual, areaConfig);
    else
      this.areaSequeiro = this.calculaAreaRestante(this.areaSequeiro, areaAtual, areaConfig);

      this.areaTotalSafra = this.calcAreaTotalSafra();

      if(this.areaSequeiro.filter(x => x.AreaDisponivel < 0).length > 0 || this.areaIrrigada.filter(x => x.AreaDisponivel < 0).length > 0){
        this.utils.handleWarning("A area utlizada configurada ultrapassa o saldo disponível para essa área.");
        this.configurarArea(areaRef, false);
     }

    // let areaAtual = this.areasSafra.filter(a => a.Id == area.Id && (a.PlanejamentoId == null || a.PlanejamentoId == area.PlanejamentoId));
    // if (areaAtual.length > 0)
    //   if (area.Selecionada)
    //     areaAtual[0].AreaUtilizada = area.AreaUtilizada;
    //   else
    //     this.areasSafra.splice(this.areasSafra.indexOf(area), 1);
    // else
    //   if (area.Selecionada)
    //   {
    //       this.areasSafra.push(area);
    //       let areas:Area[] = [];
    //       areas.push(area);
    //       this.areasPlanejamento.push({AreaId: area.Id, Areas: areas});
    //   }




  //   let totalArea = 0;
  //   this.areasSafra.filter(a => a.Id == area.Id).forEach(a => {totalArea += a.AreaUtilizada;});
  //   if (areaAtual[0].AreaUtilizada < area.AreaDisponivel) {
  //     let saldo = area.AreaDisponivel - areaAtual[0].AreaUtilizada;
  //     //this.areaIrrigada.push({ descricao, saldo });
  //     // Ordenar o array pela descrição da área
  //     this.areaIrrigada.sort((a, b) => a.Descricao.localeCompare(b.Descricao));
  // }
  //   this.areaTotalSafra = this.calcAreaTotalSafra();
  //   if (!area.Selecionada)
  //     area.AreaUtilizada = area.AreaDisponivel;
  }

  getAreasConfiguradas(id:number) : Area[]{
    if(this.areasPlanejamento == null || this.areasPlanejamento.length == 0 || isNull(this.areasPlanejamento))
      return [];
    let areasConfig = this.areasPlanejamento.filter(x => x.AreaId == id);
    if(areasConfig == null || isNull(areasConfig) || areasConfig.length === 0)
      return [];
    let areas = areasConfig[0].Areas;
    if(areas == null || isNull(areas) || areas.length === 0)
      return [];
    if(areas == null || isNull(areas))
      return [];
    return areas;
  }

  calcAreaTotalSafra():number {
    let total = 0;
    this.areasPlanejamento.forEach(a => {
      a.Areas.forEach(x => {
        total += x.AreaUtilizada;
      });
    });
    return total;
    // let total = 0;
    // this.areasSafra.forEach(a => {
    //   if (a.AreaUtilizada > a.AreaDisponivel)
    //     a.AreaUtilizada = a.AreaDisponivel;

    //   total += a.AreaUtilizada;
    // });

    // return total;
  }

  timoutArea: any;
  changeAreaPlantada(area: Area){
    if (this.timoutArea)
      clearTimeout(this.timoutArea);

    this.timoutArea = setTimeout(() => {
      if (area.AreaUtilizada != 0){
        area.Selecionada = true;
        this.changeArea(area);
      }
    }, 1000);
  }

  changeCultivar(area: Area){
    if (area.AreaUtilizada != 0){
      area.Selecionada = true;
      this.changeArea(area);
    }

    this.changePrevisaoPlantio(area, area.DataPrevistaPlantio);
  }

  changeCultivarGeral(){
    if(this.safraModal.PlanoMestreProducaoId && this.auxAreas){
      this.auxAreas.forEach(x => {
        x.PlanoMestreProducaoId = this.safraModal.PlanoMestreProducaoId
      })
    }
  }
  changePrevisaoPlantio(area: Area, dataPrevisao: Date) {
    if (dataPrevisao) {
      area.DataPrevistaPlantio = dataPrevisao;
      let cultivar = this.cultivares.filter(c => c.Id == area.VariedadeId)[0];
      if (cultivar)
        area.DataPrevistaColheita = new Date(dataPrevisao.getTime() + (cultivar.Ciclo*24*60*60*1000));
    }
  }

  filtrarAreas(textoBusca: string){
    this.textoBuscaArea = textoBusca;
    this.areas = this.auxAreas.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBuscaArea.toUpperCase()) ||
      x.Id.toString().includes(this.textoBuscaArea)
      );
    this.areaIrrigada = this.getAreaPorFazenda(true);
    this.areaSequeiro = this.getAreaPorFazenda(false);
  }

  private filtraAreaComPredicate(predicate: (a: Area) => boolean, mensagem: string): string{
    let areasConfig = this.getAreasConfig(true).concat(this.getAreasConfig(false));
    const areasFilter = areasConfig.filter(predicate);
    if(areasFilter.length == 0) return ''

    const areasDescricao = areasFilter
      .map(a => a.Descricao)
      .join(', ');

    return `${mensagem} ${areasDescricao}`
  }

  private semPrevisaoPlantio(): string {
    const mensagem = 'previsão de plantio para a seguintes Áreas : ';
    return this.filtraAreaComPredicate(a => a.Selecionada && !a.DataPrevistaPlantio, mensagem);
  }

  private semVariedades(): string {
    const mensagem = 'variedade para a seguintes Áreas: ';
    return this.filtraAreaComPredicate(a => a.Selecionada && !a.VariedadeId, mensagem);
  }

  private validar(): string{
    let areasConfig:Area[] = this.getAreasConfig(true).concat(this.getAreasConfig(false));
    if(areasConfig.length == 0) return 'Selecione uma Area'
    if(this.semPrevisaoPlantio().length > 0) return this.semPrevisaoPlantio()
    if(this.semVariedades().length > 0) return this.semVariedades()
    return '';
  }

  atualizarSomenteSafra(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }
    let areasConfig:Area[] = this.getAreasConfig(true).concat(this.getAreasConfig(false));
    this.areasSafra = areasConfig;
    this.carregando = true;
    this.safraService.putSafra(this.safraModal.Id, this.safraModal).subscribe(
      res => {
        this.toasty.show('Feito!', 'Safra atualizada!', 'success');
        this.carregando = false;
        this.safraSelecionada = this.safraModal;
        //this.selecionarSafra(new Safra());
        this.mostraEdicaoSafra = false;
        this.edicaoSafra.emit(this.mostraEdicaoSafra);
        //this.listarSafras();
      },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      });
  }


  getCultivaresPorCultura(culturaId: number) : Cultivar[] {
    if (!this.cultivares || !culturaId)
      return [];

    let cultivares = this.cultivares.filter(x =>
      x.CulturaId==culturaId
    );

    return cultivares;
  }

  getVariedadesPorPlanejamento(planejamentoId: number) : Cultivar[] {
    if (!this.planosMestre || !planejamentoId || !this.cultivares)
      return [];

    let plano = this.planosMestre.find(x => x.Id == planejamentoId);

    let variedades = this.cultivares.filter(x =>
      x.CultivarBaseId == plano.CultivarId
    );

    return variedades;
  }

  confirmExcluirCultura(cultura: Cultura): void{
    Swal.fire({
      title: 'Você tem certeza desta ação?',
      text:
        'A Cultura e os Talhões associados a ela serão removidos do Ano Safra caso não possuam Ordens de Serviço em execução. Essa ação é irreversível!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Remover Cultura',
    }).then((response) => {
      if (!response.dismiss) {
        //this.validaExcluirCultura(cultura)
        this.excluirCultura(cultura)
      }
    })
  }

  validaExcluirCultura(cultura: Cultura): void {
    console.debug('validar cultura para excluir')
    new Observable<any>().subscribe(
      (res) => {
        // verificar retorno e verificar qual o tipo de erro de validacao caso tenha
        // alinhar com a api, pra lancar exception pra n precisar lancar alert de erro aqui
        if(res) this.excluirCultura(cultura)
        else this.utils.alertError('Esta ação não pôde ser realizada!',
      'Para que uma Cultura possa ser removida de um Ano Safra, não deve possuir Ordens de Serviço concluídas ou em execução vinculadas nos Talhões associados!')
      },
      (err) => {
        this.utils.getErro(err)
      }
    )
  }
  excluirCultura(cultura: Cultura): void{
    this.safraService.excluirCultura(cultura.Id, this.anoSafraSelecionado.Id).subscribe(
      res => {
        // this.listarCulturas();
        this.utils.handleSuccess('Cultura removida com sucesso.')
      },
      err => {
        this.utils.getErro(err)
      }
    )
  }

  openEdit(item: AnoSafra){
    this.anoSafraEdit = {...item} as AnoSafra;
    //this.modalEdit.show();
  }
  getProcessoPlanejamento(id: number): ProcessoPlanejamento{
    if(this.processosPlanejamento)
      return this.processosPlanejamento.filter(x => x.Id == id)[0];
    return null;
  }

  async getAnosSafras(): Promise<void>{
    this.anosSafras = await this.anoSafraService.getAnosSafrasPorFazenda(this.fazendaId).toPromise()
    console.debug('anosSafras: ', this.anosSafras)
    // subscribe(ret =>{
    //   this.anosSafras = ret;
    // });
  }

  async finalizarSaveAnoSafra(anoSafraEvent: AnoSafra): Promise<void>{
    await this.getAnosSafras();
    this.attListaAnosSafras.emit(this.anosSafras)
    console.debug('finalizarSaveAnoSafra', this.anosSafras)
    if(anoSafraEvent && anoSafraEvent.Id > 0){
      this.selecionarAnoSafra(anoSafraEvent);
    }
    else{
      const ultimoCriado = this.anosSafras.reduce((maisRecente, atual) => {
      return new Date(atual.DataCadastro) > new Date(maisRecente.DataCadastro)
        ? atual
        : maisRecente;
      });
      this.selecionarAnoSafra(ultimoCriado);
    }
  }
  configurarTraducao() {
    this.ERRO = this.translate.instant('ERRO');
    this.FEITO = this.translate.instant('FEITO');
    this.ANO_SAFRA_DELETADO = this.translate.instant('ANO_SAFRA_DELETADO');
    this.NAO_E_POSSIVEL_EXCLUIR_UM_ANO_SAFRA_QUE_POSSUI_SAFRAS = this.translate.instant('NAO_E_POSSIVEL_EXCLUIR_UM_ANO_SAFRA_QUE_POSSUI_SAFRAS');
    this.SIM = this.translate.instant('SIM');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.ANO_SAFRA_ALTERADO = this.translate.instant('ANO_SAFRA_ALTERADO');
    this.ANO_SAFRA_CADASTRADO = this.translate.instant('ANO_SAFRA_CADASTRADO');
    this.SAFRA_FINALIZADA = this.translate.instant('SAFRA_FINALIZADA');
    this.FINALIZAR_ESTA_SAFRA = this.translate.instant('FINALIZAR_ESTA_SAFRA');
    this.SAFRA_DELETADA = this.translate.instant('SAFRA_DELETADA');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA_CASO_JA_TENHAM_ORDENS_DE_SERVICOS_GERADAS_TAMBEM_SERAO_EXCLUIDAS = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA_CASO_JA_TENHAM_ORDENS_DE_SERVICOS_GERADAS_TAMBEM_SERAO_EXCLUIDAS');
    this.SAFRA_CADASTRADA = this.translate.instant('SAFRA_CADASTRADA');
    this.SAFRA_REABERTA = this.translate.instant('SAFRA_REABERTA');
    this.REABRIR_ESTA_SAFRA = this.translate.instant('REABRIR_ESTA_SAFRA');
  }

  excluirAnoSafra(event: any){
    this.onExcluirAnoSafra.emit(event);
  }

  onOperacaoAnoSafra(event: boolean){
    this.onOperacaoAnoSafraEvent.emit(event);
  }
}
